import getMatchedMedia, { listeners } from './getMatchedMedia';

export default function addMediaListener(listener, callInitial = true) {
  listeners.push(listener);

  if (callInitial) {
    listener(getMatchedMedia());
  }

  return () => {
    listeners.splice(listeners.indexOf(listener), 1);
  };
}
